/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancerApplicationStatus = {
    InvitationSent: 'INVITATION_SENT',
    WaitingForQuote: 'WAITING_FOR_QUOTE',
    NewQuote: 'NEW_QUOTE',
    QuoteAccepted: 'QUOTE_ACCEPTED'
} as const;
export type FreelancerApplicationStatus = typeof FreelancerApplicationStatus[keyof typeof FreelancerApplicationStatus];


export function instanceOfFreelancerApplicationStatus(value: any): boolean {
    for (const key in FreelancerApplicationStatus) {
        if (Object.prototype.hasOwnProperty.call(FreelancerApplicationStatus, key)) {
            // @ts-ignore
            if (FreelancerApplicationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancerApplicationStatusFromJSON(json: any): FreelancerApplicationStatus {
    return FreelancerApplicationStatusFromJSONTyped(json, false);
}

export function FreelancerApplicationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerApplicationStatus {
    return json as FreelancerApplicationStatus;
}

export function FreelancerApplicationStatusToJSON(value?: FreelancerApplicationStatus | null): any {
    return value as any;
}

